export class Brand {
    id: number;
    code: string;
    name: string;
    state: any;
}